var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.962,
    height: 13,
    viewBox: "0 0 14.962 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon_tick-mark",
    d: "M77.35,120.948a37.178,37.178,0,0,0-8.377,11.591.232.232,0,0,1-.186.149.048.048,0,0,1-.038.012.21.21,0,0,1-.174-.075l-6.108-6.207A12.448,12.448,0,0,1,64.35,124.8l3.353,2.63a39.185,39.185,0,0,1,8.973-7.727,7.131,7.131,0,0,1,.735.973.248.248,0,0,1-.062.275Z",
    transform: "translate(-62.467 -119.7)",
    fill: "#32e2a9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck2);
export default __webpack_public_path__ + "static/media/check2.54e1956ed56ede102835c043c8b56bf6.svg";
export { ForwardRef as ReactComponent };